$('#counter strong').each(function() {
      var $this = $(this);
      var priceText = $this.text().replace(/[^0-9]/g, '');
      var price = parseInt(priceText);

      $({ Counter: 0 }).animate({ Counter: price }, {
          duration: 2000,
          easing: 'swing',
          step: function(now) {
              $this.text( Math.floor(now));
          }
      });
  });